import React, { useState } from "react";
import ProductCard from "./ProductCard";

const ProductsSection = ({ title, products, onProductSelect, defaultExpanded = false }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className={`revamp-section ${expanded ? "revamp-section--expanded" : "revamp-section--collapsed"}`}>
      <button
        className="revamp-section__header"
        onClick={() => setExpanded(!expanded)}
      >
        <div className="revamp-section__header-left">
          <h3 className="revamp-section__title">{title}</h3>
          <span className="revamp-section__count">
            {products.length} product{products.length !== 1 ? "s" : ""}
          </span>
        </div>
        <div className={`revamp-section__chevron ${expanded ? "revamp-section__chevron--open" : ""}`}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </button>
      <div className={`revamp-section__body ${expanded ? "revamp-section__body--visible" : ""}`}>
        <div className="revamp-products-grid">
          {products.map((product) => (
            <ProductCard
              key={product.variantId}
              product={product}
              onSelect={onProductSelect}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductsSection;
